"use strict";

var _taggedTemplateLiteral = require("/codebuild/output/src213846038/src/github.com/rteamweb/web-marketing-ui/application/node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10;

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ContentSection = void 0;

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var styled_1 = __importDefault(require("@emotion/styled"));

var frontend_theme_1 = require("@ryerson/frontend.theme");

var Container_1 = require("./Container");

var react_1 = require("@emotion/react");

var Container_2 = require("./Container");

var _1 = require("./");

var RootContainer = styled_1.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\t", "\n"])), function (props) {
  var theme = props.theme,
      type = props.type,
      split = props.split;
  var customBackground = type === "split";
  var backgroundStyle = !customBackground && "background-color: ".concat(theme.colors[type].background);

  if (customBackground && split.splitColors && split.splitColors.length) {
    if (split.splitColors.length === 1) {
      backgroundStyle = "background: ".concat(split.splitColors[0].color);
    } else {
      backgroundStyle = "background: linear-gradient(".concat(split.splitDirection === "vertical" ? "180deg" : "90deg", ",").concat(split.splitColors[0].color, " ").concat(split.splitColors[0].percentage, ", ").concat(split.splitColors[1].color, " ").concat(split.splitColors[0].percentage, ")");
    }
  }

  return (0, react_1.css)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n\t\t\t", ";\n\t\t\tfont-family: ", ";\n\t\t"])), backgroundStyle, theme.typography.fontFamilies.primary);
});
var OuterContainer = styled_1.default.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n\twidth: 100%;\n\tmargin-left: auto;\n\tmargin-right: auto;\n\tbox-sizing: border-box;\n\tposition: relative;\n\t*,\n\t::after,\n\t::before {\n\t\tbox-sizing: inherit;\n\t}\n\t", "\n"])), function (props) {
  var breakpoint = props.breakpoint;
  return (0, react_1.css)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n\t\t\tmax-width: ", ";\n\t\t"])), breakpoint);
});
var Image = styled_1.default.img(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n\t", "\n"])), function (props) {
  var split = props.split;
  return split ? (0, react_1.css)(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n\t\t\t\t\theight: 100%;\n\t\t\t  "]))) : (0, react_1.css)(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n\t\t\t\t\twidth: 100%;\n\t\t\t  "])));
});
var imageContainer = (0, react_1.css)(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n\tposition: absolute;\n\toverflow: hidden;\n\theight: 100%;\n\twidth: 100%;\n\tz-index: -1;\n"])));

var ContentSection = function ContentSection(_ref) {
  var children = _ref.children,
      _ref$hPadding = _ref.hPadding,
      hPadding = _ref$hPadding === void 0 ? Container_2.DEFAULT_PADDING : _ref$hPadding,
      _ref$vPadding = _ref.vPadding,
      vPadding = _ref$vPadding === void 0 ? Container_2.DEFAULT_PADDING : _ref$vPadding,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? "primary" : _ref$type,
      split = _ref.split,
      width = _ref.width,
      dataTestId = _ref.dataTestId;

  var _ref2 = (0, frontend_theme_1.useTheme)(),
      theme = _ref2.theme;

  var breakpoint = "1920px";
  return (0, jsx_runtime_1.jsx)(RootContainer, {
    theme: theme,
    type: type,
    split: split,
    "data-testid": dataTestId,
    children: (0, jsx_runtime_1.jsxs)(OuterContainer, {
      breakpoint: breakpoint,
      theme: theme,
      type: type,
      split: split,
      children: [(0, jsx_runtime_1.jsxs)(_1.Flex, {
        style: imageContainer,
        direction: split && (split === null || split === void 0 ? void 0 : split.splitImage) && (split === null || split === void 0 ? void 0 : split.splitImage[0].position) === "right" ? "row-reverse" : "row",
        children: [split && (split === null || split === void 0 ? void 0 : split.splitImage) && (split === null || split === void 0 ? void 0 : split.splitImage.length) >= 1 && (0, jsx_runtime_1.jsx)(_1.Flex, {
          justifyContent: (split === null || split === void 0 ? void 0 : split.splitImage[0].position) === "left" ? "flex-end" : (split === null || split === void 0 ? void 0 : split.splitImage[0].position) === "right" ? "flex-start" : "center",
          alignItems: "center",
          style: (0, react_1.css)(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n\t\t\t\t\t\t\t\twidth: ", ";\n\t\t\t\t\t\t\t"])), split === null || split === void 0 ? void 0 : split.splitImage[0].percentage),
          children: (0, jsx_runtime_1.jsx)(Image, {
            src: split.splitImage[0].imageUrl,
            split: (split === null || split === void 0 ? void 0 : split.splitImage.length) === 2 || (split === null || split === void 0 ? void 0 : split.splitImage[0].percentage) !== "100%"
          })
        }), split && (split === null || split === void 0 ? void 0 : split.splitImage) && (split === null || split === void 0 ? void 0 : split.splitImage.length) === 2 && (0, jsx_runtime_1.jsx)(_1.Flex, {
          justifyContent: (split === null || split === void 0 ? void 0 : split.splitImage[0].position) === "right" ? "flex-end" : "flex-start",
          style: (0, react_1.css)(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n\t\t\t\t\t\t\t\twidth: ", ";\n\t\t\t\t\t\t\t"])), split === null || split === void 0 ? void 0 : split.splitImage[1].percentage),
          children: (0, jsx_runtime_1.jsx)(Image, {
            src: split.splitImage[1].imageUrl,
            split: (split === null || split === void 0 ? void 0 : split.splitImage.length) === 2
          })
        })]
      }), (0, jsx_runtime_1.jsx)(Container_1.Container, {
        width: width,
        vPadding: vPadding,
        hPadding: hPadding,
        children: children
      })]
    })
  });
};

exports.ContentSection = ContentSection;